export default "__VITE_ASSET__D_dV36B5__"